
export function ContactUs({ className = 'underline', children = 'contact us' }) {
	const openContactModal = e => {
		e.preventDefault();
		app.trigger(app.events.SHOW_POPUP, {pt: "contact", txt: 'Contact Us', u: 'contact-us'})
	};

	return <a href="#" className={className} onClick={openContactModal}>{children}</a>;
}
